import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'
import { WorkflowDiagram } from './workflow-diagram'
import { OAC, OAC_PLATFORMS } from '@/content/oac'

export function OacSection() {
  return (
    <PremiumSection id="oac" containerClassName="max-w-4xl">
      <p className="mb-4 font-mono text-sm text-[#8b958f]">
        Free and open source
      </p>
      <PremiumHeading as="h2">{OAC.name}</PremiumHeading>

      <p className="mb-6 max-w-2xl leading-relaxed text-[#c3ccc7]">
        {OAC.description}
      </p>

      <div className="mb-2.5 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-sm text-[#8b958f]">
        <span>
          <span className="text-[#f0f3f1]">{OAC.stars}</span> stars
        </span>
        <span>
          <span className="text-[#f0f3f1]">{OAC.forks}</span> forks
        </span>
        <span>{OAC.license} licence</span>
      </div>
      <p className="mb-10 font-mono text-sm text-[#8b958f]">{OAC_PLATFORMS}</p>

      {/* This replaced four prose bullets. Three of them were describing the
          pipeline the diagram now draws; the fourth is the line above. */}
      <WorkflowDiagram />

      {/* Wrap rather than scroll — a curl command that runs off the edge
          reads as truncated, and people copy it by selecting it. */}
      <div className="mb-6 rounded-lg border border-[#232a26] bg-[#141817] p-4">
        <code className="block break-all font-mono text-sm leading-relaxed text-[#c3ccc7]">
          {OAC.installCommand}
        </code>
      </div>
      <p className="mb-8 text-sm text-[#8b958f]">{OAC.prerequisite}</p>

      <a
        href={OAC.repoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex justify-center rounded-lg border border-[#2e3833] px-7 py-3.5 font-semibold text-[#f0f3f1] transition-colors hover:border-[#80cca5]/50 hover:text-[#80cca5]"
      >
        See it on GitHub →
      </a>
    </PremiumSection>
  )
}
